import type {
  TavilySearchConfig,
  WebSearchConfig,
} from '@/types/webSearch.types';

export interface WebSearchToggleState {
  enabled: boolean;
  useAdvanced: boolean;
}

/**
 * Overlay the user's per-agent toggle state onto the agent's
 * webSearchConfig. Returns `null` when the toggle is off or the agent
 * has no config — callers treat null as "skip web search this turn".
 *
 * When advancedAvailable is true (admin already chose 'advanced' for
 * Tavily), the user can downgrade to 'basic' via the Advanced pill.
 * Otherwise the agent's configured depth is passed through unchanged.
 */
export function buildEffectiveWebSearchConfig(
  agentConfig: WebSearchConfig | undefined,
  toggle: WebSearchToggleState,
  advancedAvailable: boolean
): WebSearchConfig | null {
  if (!agentConfig) return null;
  if (!toggle.enabled) return null;

  if (advancedAvailable && agentConfig.provider === 'tavily') {
    const tavily = agentConfig as TavilySearchConfig;
    const next: TavilySearchConfig = {
      ...tavily,
      searchDepth: toggle.useAdvanced ? 'advanced' : 'basic',
    };
    return next;
  }
  return agentConfig;
}
